import React from 'react';
import liveclassimage from "../images/white-double-arrow.png";
import LiveClassWidget from "./liveClassWidget.js";
import { useContext, useEffect, useState } from "react";
import SglContext from '../SglContext';


function LiveClassWidgetMobile(){
    const [popup, setPop] = useState(false);
    const Sgl =useContext(SglContext)

    useEffect(() => {
        fetchLiveClassWidgetData();
      }, []);
    
      function fetchLiveClassWidgetData() {
    
            if (!Sgl.exists_live_classes) {
              var live_btn_mobile = document.getElementById("live-class-btn");
              if (live_btn_mobile) {
                live_btn_mobile.style.setProperty("display", "none", "important");
              }
            } else {
              var live_btn_mobile = document.getElementById("live-class-btn");
              if (live_btn_mobile) {
                live_btn_mobile.classList.add("mobile-button-show");
              }
            }
      }
    
    
  function closePopup() {
    setPop(false);
    var popup = document.getElementById("myPopupp");
    popup.classList.remove("show");
    document.getElementById("live-classes-popup-overlayy").style.display =
      "none";
  }
  function openPopup() {
    setPop(!popup);
    var popup = document.getElementById("myPopupp");
    // popup.innerHTML = '<div className="popup-loader"></div>';
    fetchLiveClassWidgetData();
    // var liveClassBtn = document.getElementById("live-class-btn-desktop");
    // if (liveClassBtn) {
    //   popup.style.top = liveClassBtn.offsetTop - 15 + "px";
    // }
    popup.classList.toggle("show");
    document.getElementById("live-classes-popup-overlayy").style.display =
      "block";
  }


    return <div>

<aside
          id='live-class-widget-section'
          className='live-class-widget-section'>

          <div className='sgl-plugin-page sgl-plugin'>
            <div id='live-classes-popup-overlayy' onClick={closePopup}></div>
            <div className='popuptext ' id='myPopupp'>
                {(popup) && 
                <LiveClassWidget 
                id='liveClassWidgetData'
                closePopup={closePopup}
                popup = {popup}
              />
              }
              
            </div>
            <button style={{backgroundColor: '#40913f'}} 
              className='live-class-btn'
              // className='live-class-btn mobile-button-show'
              id='live-class-btn'
              onClick={openPopup}>
              <img className='arrow-icon' src={liveclassimage} /> LIVE
            </button>
          </div>
        </aside>
    </div>;
}

export default LiveClassWidgetMobile;